export default __webpack_public_path__ + "static/media/1812.684700dd.png";